import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';
import { ReactComponent as CustomerIcon } from 'assets/icons/user-check.svg';

import { IS_VC_UNIT_CARD_DETAILS_VISIBLE } from '../../../../../../constants/general';
import { formatRevenueAndPercentage } from '../../../../../../utils/helpers';
import CustomNodeItem from '../../BusinessStructure/components/CustomNodeItem';

import type { ICustomerNode } from '../interfaces/ICustomerNode';

import styles from '../sass/CustomUnitNode.module.scss';

function CustomerNode({
  name,
  totalRevenueRolling12MPercents,
  naceSection,
  addressCountry,
  profitCenterIds,
  totalCost,
  isCollapsed,
  isDraft,
  showDraftDeleteButton = true,
  cardsInsideCount,
  onDraftDelete,
}: ICustomerNode) {
  const { t } = useTranslation();

  const customNodeItems = [
    {
      title: t('valueChainMap.profitCenterId'),
      value: profitCenterIds?.join(', ') || '-',
    },
    {
      title: t('valueChainMap.industryNace'),
      value: naceSection || '-',
      isCapitalize: true,
    },
    {
      title: t('valueChainMap.country'),
      value: addressCountry || '-',
      isCapitalize: true,
    },
    {
      title: t('valueChainMap.actualRevenue'),
      value: formatRevenueAndPercentage({
        actual: totalCost?.amount,
        currency: totalCost?.currency,
        percentage: totalRevenueRolling12MPercents?.toString(),
      }),
    },
  ];

  return (
    <>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <CustomerIcon />
          <p className={styles.title}>{name}</p>
        </div>
        <div className={styles.headerRight}>
          {isCollapsed && cardsInsideCount && cardsInsideCount > 0 ? (
            <span className={styles.cardsCount}>{cardsInsideCount}</span>
          ) : null}
          {isDraft && showDraftDeleteButton ? (
            <button
              type="button"
              className={styles.draftDeleteButton}
              aria-label={t('common.delete')}
              onClick={(event) => {
                event.stopPropagation();
                onDraftDelete?.();
              }}
            >
              <TrashIcon className={styles.draftDeleteIcon} />
            </button>
          ) : null}
        </div>
      </div>
      {IS_VC_UNIT_CARD_DETAILS_VISIBLE && !isCollapsed ? (
        <div className={styles.content}>
          {customNodeItems.map(({ title, value, isCapitalize }) => (
            <CustomNodeItem
              key={`customNodeItems_${title}`}
              title={title}
              value={value}
              isCapitalize={isCapitalize}
            />
          ))}
        </div>
      ) : null}
    </>
  );
}

export default CustomerNode;
